<template lang="pug">
  .products
    v-app-bar.white(app flat)
      v-container.pa-0(style="max-width:600px")
        v-layout
          h5.ml-2 Products
          v-spacer
          v-chip.mr-4.my-auto.primary.caption.font-weight-bold(rounded outlined small) Total: {{ totalPrice | displayPrice }}
          div(@click="showCatalogItemsDialog = true" style="cursor:pointer;")
            v-badge.my-1.mr-2(:content='productCount', :value='productCount', color='accent' overlap bordered)
              v-icon.mr-1 mdi-shopping
    v-container.white(style="max-width:600px")
      v-layout.mt-2
        v-text-field(v-model="searchText" placeholder='Search product' hide-details dense outlined height="40" background-color="basic200")
          template(v-slot:append)
            eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")
        //- v-text-field(v-model="searchText" prepend-inner-icon="mdi-shopping-search" label='Search product' hide-details dense rounded outlined)
      //- v-layout.mt-3
      //-   v-spacer
      //-   v-menu(left :offset-y='true' max-height="50%")
      //-     template(v-slot:activator='{ on }')
      //-       v-chip.my-auto.px-3(small filled color="primary" v-on="on")
      //-         div.white--text {{ filter_text }}
      //-         v-icon(right small color="white") mdi-chevron-down
      //-     v-list
      //-       v-list-item.my-n2(v-for="(filter, index) in filters" :key="filter.id" @click="selectedFilter = index")
      //-         v-list-item-title {{ filter.name }}
    v-container.pa-0(style="max-width:600px")
      v-layout.my-6(v-if="isProductFetching || isRestructureFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .contain-layout(v-else)
        v-layout.my-6(v-if="products.length == 0")
          v-row.fill-height.ma-0(align='center' justify='center')
            div.mx-auto
              v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
              p.caption Products not found or empty
        .items-layout(v-else)
          template(v-for='(product, index) in products')
            v-row(no-gutters align="center")
              v-col.pl-1.shrink
                v-card(flat)
                  v-img(:src="product.image ? product.image.file : require('@/assets/image_placeholder.png')" aspect-ratio="1" width="92px")
              v-col.pa-2
                div.text-body-1.basic800--text.mb-1 {{ product.name }}
                div.text-caption.basic600--text.product-description.mb-1(v-html="product.description")
                div.d-flex.align-center
                  div.text-body-2.basic600--text {{ product.price | displayPrice }}
                  v-spacer
                  div.d-flex.align-center
                    v-btn(icon @click="clickPlusMinus(product, 'minus')" :disabled="getQuantity(product) == 0")
                      v-icon(color="accent") mdi-minus-circle
                    div.colbox.text-center
                      span.text-body-2 {{ getQuantity(product) }}
                    v-btn(icon @click="clickPlusMinus(product, 'plus')" :disabled="product.inventory_enabled && product.inventory_qty <= getQuantity(product)")
                      v-icon(color="accent") mdi-plus-circle
            v-divider.basic300

      div.mt-4
        v-pagination.mt-4(v-if="totalPage >= 2" v-model='page' :length='totalPage' :total-visible="6")

    v-footer.white(fixed app)
      v-container.px-0(style="max-width:580px")
        v-btn.accent(block :loading="isUpdating" @click="updateProducts") {{ 'save' }}

    .productOptions(style="max-width:500px")
      variants(v-if="openVariants" :open.sync="openVariants" :product.sync="vProduct" :inventory.sync="vInventory" language="en" @finalVariants="getVariants($event)")

    .productAddons(style="max-width:500px")
      addons(v-if="openAddons" :open.sync="openAddons" :product="aProduct" :inventory.sync="aInventory" language="en" @finalProdAddon="getProdAddon($event)")

    .modals
      catalog-items-dialog(v-if="showCatalogItemsDialog" :open.sync="showCatalogItemsDialog" :products="selectedProducts")

</template>

<script>
import { mapActions } from 'vuex'
import queryString from 'query-string'
import CatalogItemsDialog from '@/views/invoice/components/CatalogItemsDialog'
import Variants from '@/components/forms/Variants.vue'
import Addons from '@/components/forms/Addons.vue'
import ShowMoreText from '@/components/ShowMoreText'
export default {
  name: 'UpdateProducts',
  components: { CatalogItemsDialog, Variants, Addons, ShowMoreText },
  props: ['lead'],
  data: () => ({
    isProductFetching: false,
    isFetchingArray: [],
    showCatalogItemsDialog: false,
    fetchCount: 12,
    page: 1,
    totalPage: 1,
    products: [],
    searchText: '',
    searchCountDown: null,
    selectedProducts: [],
    isUpdating: false,
    filters: [],
    selectedFilter: 0,
    searchfilter: '',
    filter_text: 'All Product',
    openVariants: false,
    openAddons: false,
    vProduct: null,
    vVariants: null,
    vInventory: null,
    vOrderLimit: null,
    aProduct: null,
    aInventory: { inv_enable: false, inv_qty: 0 },
    categories: [],
    categoryParams: '',
  }),
  computed: {
    productCount () {
      return this.selectedProducts.filter(f => f.quantity > 0).map(m => { return m.quantity }).reduce((total, num) => { return total + num }, 0)
    },
    totalPrice() {
      let total = 0
      this.selectedProducts.forEach(o => {
        if (o.variant_products) {
          o.variant_products.forEach(r => {
            total += (r.price * r.quantity)
          })
        } else if (o.addon_products) {
          o.addon_products.forEach(r => {
            r.addons.forEach(c => {
              total += ((r.price + (c.price + c.quantity_per_set)) * r.quantity)
            })
          })
        } else {
          total += (o.price * o.quantity)
        }
      })
      return total
    },
    isRestructureFetching () {
      if (this.isFetchingArray.length > 0) {
        return true
      } else {
        return false
      }
    }
  },
  watch: {
    page (val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isProductFetching) {
        this.fetchProducts(val)
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem()
      }, 500)
    },
    selectedFilter(val) {
      const filter = this.filters[val]
      this.searchfilter = filter.id
      this.filter_text = filter.name
      this.searchItem()
    },
  },
  mounted () {
    if (this.lead.form.type === 'store') {
      if (!this.$route.query.page) {
        this.fetchCategories(1)
      } else {
        this.fetchCategories(this.$route.query.page)
      }
    } else {
      if (!this.$route.query.page) {
        this.fetchProducts(1)
      } else {
        this.fetchProducts(this.$route.query.page)
      }
    }
    this.restructureProduct()
    // this.fetchForms()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    restructureProduct () {
      let productId = []
      let product_restr = []
      const distinct = (value, index, self) => {
        return self.indexOf(value) === index
      }
      this.lead.products.forEach(o => {
        o.product.variant_for ? productId.push(o.product.variant_for) : productId.push(o.product.id)
        if (o.product.variant_for) {
          product_restr.push({
            id: o.product.id,
            edit_id: o.id,
            name: o.name,
            price: o.product.price,
            discount: o.discount,
            discountValue: o.discount/100,
            quantity: o.quantity,
            variant_for: o.product.variant_for,
            addons: []
          })
        } else if (o.addons.length > 0) {
          product_restr.push({
            id: o.product.id,
            edit_id: o.id,
            name: o.name,
            price: o.product.price,
            discount: o.discount,
            discountValue: o.discount/100,
            quantity: o.quantity,
            variant_for: null,
            addons: [...o.addons.map(m => { return { 
              id: m.product.id,
              edit_id: m.id,
              name: m.name,
              price: m.product.price,
              quantity_per_set: m.quantity_per_set
            }})]
          })
        } else if (o.bundles.length > 0) {
          // DO NOTHING
        } else {
          product_restr.push({
            id: o.product.id,
            edit_id: o.id,
            name: o.name,
            price: o.product.price,
            discount: o.discount,
            discountValue: o.discount/100,
            quantity: o.quantity,
            variant_for: null,
            addons: []
          })
        }
      })
      productId.filter(distinct).forEach((o) => {
        this.isFetchingArray.push(true)
        this.$axios.get(`/products/${o}/?expand=variants,options`)
        .then(resp => {
          if (resp.data.has_variants) {
            // console.log('variants', resp.data,)
            let variants = product_restr.filter(f => f.variant_for === o).map(m => { return { ...m, selectedOptions: resp.data.variants.find(f => f.product.id === m.id).specs.map(p => { return { id: resp.data.options.find(i => i.specs.map(a => a.id).includes(p)).id, selected: p } }) } })
            const item = {
              id: resp.data.id,
              edit_id: null,
              name: resp.data.name,
              description: resp.data.description,
              price: resp.data.price,
              image: resp.data.image,
              discount: variants[0].discount,
              discountValue: variants[0].discount/100,
              quantity: variants.map(m => { return m.quantity }).reduce((total, num) => { return total + num }, 0),
              variants: resp.data.variants,
              variant_products: [...variants],
              option: resp.data.options,
              has_variants: true,
              has_addons: false,
              openEditDiscount: false,
              inventory_enabled: resp.data.inventory_enabled,
              inventory_qty: resp.data.inventory_qty
            }
            this.selectedProducts.push(item)
          } else if (resp.data.has_addons) {
            // console.log('addons', resp.data,)
            let productWithAddons = product_restr.filter(f => f.id === o)
            const item = {
              id: resp.data.id,
              edit_id: null,
              name: resp.data.name,
              description: resp.data.description,
              price: resp.data.price,
              image: resp.data.image,
              discount: productWithAddons[0].discount,
              discountValue: productWithAddons[0].discount/100,
              quantity: productWithAddons.map(m => { return m.quantity }).reduce((total, num) => { return total + num }, 0),
              addon_products: [...productWithAddons],
              has_variants: false,
              has_addons: true,
              openEditDiscount: false,
              inventory_enabled: resp.data.inventory_enabled,
              inventory_qty: resp.data.inventory_qty
            }
            this.selectedProducts.push(item)
          } else {
            // console.log('pure', resp.data,)
            let prodonly = product_restr.filter(f => f.id === o)[0]
            const item = {
              id: prodonly.id,
              edit_id: prodonly.edit_id,
              name: prodonly.name,
              description: resp.data.description,
              price: prodonly.price,
              image: resp.data.image,
              discount: prodonly.discount,
              discountValue: prodonly.discountValue,
              quantity: prodonly.quantity,
              has_variants: false,
              has_addons: false,
              openEditDiscount: false,
              inventory_enabled: resp.data.inventory_enabled,
              inventory_qty: resp.data.inventory_qty
            }
            this.selectedProducts.push(item)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingArray.pop()
        })
      })
    },
    getQuantity (product) {
      if (this.selectedProducts.find(f => f.id === product.id)) {
        return this.selectedProducts.find(f => f.id === product.id).quantity
      }
      return 0
    },
    clickPlusMinus (product, button) {
      if (this.selectedProducts.find(f => f.id === product.id)) {
        let filteredProduct = this.selectedProducts.find(f => f.id === product.id)
        if (product.has_variants) {
          this.onVariants(filteredProduct)
        } else if (product.has_addons) {
          this.onAddons(filteredProduct)
        } else {
          if (button === 'plus') {
            filteredProduct.quantity += 1
          } else {
            filteredProduct.quantity -= 1
          }
        }
      } else {
        if (product.has_variants) {
          this.selectedProducts.push({ ...product, quantity: 0 })
          this.onVariants(product)
        } else if (product.has_addons) {
          this.selectedProducts.push({ ...product, quantity: 0 })
          this.onAddons({ ...product, quantity: 0 })
        } else {
          this.selectedProducts.push({ ...product, quantity: 1 })
        }
      }
    },
    fetchCategories (page) {
      this.isProductFetching = true
      this.$axios.get(`/product_categories/?page_size=-1&company=${this.lead.company}&ordering=-id`)
        .then((resp) => {
          if (resp.data.results && resp.data.results.length > 0) {
            this.categories = resp.data.results.filter(f => f.total_products > 0)
          }
        })
        .catch(() => {})
        .finally(() => {
          this.categories.forEach((item) => {
            this.categoryParams += `&categories=${item.id}`
          })
          this.fetchProducts(page)
        })
    },
    fetchProducts(page) {
      this.page = parseInt(page)
      this.isProductFetching = true
      let fetchUrl = `/products/?page=${page}&page_size=${this.fetchCount}&company=${this.lead.company}&ordering=-id&status=published&bundle=false`
      if (this.lead.form.type === 'store') {
        fetchUrl += `${this.categoryParams}`
      } else {
        fetchUrl += `&form=${this.lead.form.id}`
      }
      this.$axios.get(fetchUrl)
      .then((response) => {
        this.isProductFetching = false
        this.products = response.data.results
        const totalCount = response.data.count
        if (totalCount % this.fetchCount == 0) {
          this.totalPage = totalCount/this.fetchCount
        } else {
          this.totalPage = totalCount/this.fetchCount + 1
        }
        this.totalPage = parseInt(this.totalPage)
      }).catch(() => {})
    },
    fetchForms() {
      this.$axios.get(`/forms?page_size=100&company=${this.lead.company}&has_product=true&status=published`)
        .then(resp => {
          if (resp.data.results.length > 0) {
            this.filters = resp.data.results
            this.filters.splice(0, 0, { name: 'All Products' })
          }
        }).catch(() => {})
    },
    searchItem () {
      let searchUrl = `/products/?page=1&page_size=${this.fetchCount}&company=${this.lead.company}&ordering=-id&status=published&bundle=false`
      if (this.searchText) {
        searchUrl += `&search=${this.searchText}`
      }
      if (this.searchfilter) {
        searchUrl += `&form=${this.searchfilter}`
      }
      if (this.lead.form.type === 'store') {
        searchUrl += `${this.categoryParams}`
      } else {
        searchUrl += `&form=${this.lead.form.id}`
      }
      this.isProductFetching = true
      this.page = 1
      this.$axios.get(searchUrl)
        .then((response) => {
          this.isProductFetching = false
          this.products = response.data.results
          const totalCount = response.data.count
          if (totalCount % this.fetchCount == 0) {
            this.totalPage = totalCount/this.fetchCount
          } else {
            this.totalPage = totalCount/this.fetchCount + 1
          }
          this.totalPage = parseInt(this.totalPage)
        }).catch(() => {})
    },
    updateProducts() {
      let finalProducts = []
      this.selectedProducts.forEach(product => {
        if (product.has_variants) {
          product.variant_products.forEach(o => {
            const item = {
              id: o.edit_id || null,
              product: o.id,
              quantity: o.quantity,
            }
            finalProducts.push(item)
          })
        } else if (product.has_addons) {
          product.addon_products.forEach(o => {
            const item = {
              id: o.edit_id || null,
              product: o.id,
              quantity: o.quantity,
              addons: [...o.addons.map(m => { return {
                id: m.edit_id || null,
                product: m.id,
                quantity_per_set: m.quantity_per_set || 0
              }}).filter(f => f.id || (!f.id && f.quantity_per_set > 0))]
            }
            finalProducts.push(item)
          })
        } else {
          const item = {
            id: product.edit_id || null,
            product: product.id,
            quantity: product.quantity,
          }
          finalProducts.push(item)
        }
      })
      if (finalProducts.filter(f => f.quantity > 0).length == 0) {
        this.showMessage(['error', this.$t('error_message.no_product_selected')])
        return
      }
      finalProducts = finalProducts.filter(f => f.id || (!f.id && f.quantity > 0))
      this.isUpdating = true
      const params = {
        products: finalProducts,
      }
      this.axios.patch(`/leads/${this.lead.pid}/`, params)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.product_updated')])
          location.href = `/invoices/${this.lead.pid}/`
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isUpdating = false
        })
    },
    onVariants (val) {
      this.vProduct = { ...val }
      this.vInventory = { inv_enable: val.inventory_enabled, inv_qty: val.inventory_qty }
      this.openVariants = true
    },
    onAddons (val) {
      this.aProduct = { ...val }
      this.aInventory = { inv_enable: val.inventory_enabled, inv_qty: val.inventory_qty }
      this.openAddons = true
    },
    getVariants (val) {
      const a = this.selectedProducts.filter(f => f.id === val.parent_id)[0]
      const b = val.variant_products
      if (b.length > 0) {
        a.variant_products = [...b]
        a.quantity = b.map(m => m.quantity).reduce((total, num) => { return total + num }, 0)
      } else {
        a.variant_products = null
        a.quantity = 0
      }
      this.vProduct = {}
    },
    getProdAddon (val) {
      let a = this.selectedProducts.filter(f => f.id === val.parent_id)[0]
      let b = val.addon_products
      if (b.length > 0) {
        a.addon_products = [...b]
        a.quantity = b.map(m => { return m.quantity }).reduce((total, num) => { return total + num }, 0)
      } else {
        a.addon_products = null,
        a.quantity = 0
      }
      this.aProduct = {}
    },
  }
}
</script>

<style scoped>
.colbox {
  border: 2px solid #5DA8DC;
  border-radius: 5px;
  width: 60px;
  height: 32px;
}
.clickable {
  cursor: pointer;
}
.product-description {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical; 
  overflow: hidden;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>
